/**
 * Created by Jan Bradac on 6.5.2016.
 *
 */

(function (Lfl, $, undefined) {
    /**
     * @memberOf Lfl
     */
     Lfl.FlashMessages;

    (function (FlashMessages, $, undefined) {
        /*
         |==============================================================================================================
         | Documentation
         |==============================================================================================================
         */

        /**
         * Displays flash messages in the correct part of the page defined by {@link Lfl.PageSectionsManager}
         * @memberOf Lfl.FlashMessages
         */
        Lfl.FlashMessages.Displayer;

        (function (Displayer, $, undefined) {
            /*
            |===========================================================================================================
            | Object definition
            |===========================================================================================================
            */

            /*
            |-----------------------------------------------------------------------------------------------------------
            | Public methods
            |-----------------------------------------------------------------------------------------------------------
            */

            // TODO MOBA II - add displayFromResponse which will automatically use the typical "place" where FM is?
            // - it is a duplication of ajax response parser - parseFlashMessages(). Link them? Or have only one?

            /**
             * @memberOf Lfl.FlashMessages.Displayer
             */
            Displayer.display = function(messageHtml) {
                var $message= $(messageHtml);

                Lfl.PageSectionsManager.getFlashMessagesSection().append($message);

                //The messages do contain javascript - evaluate it and move it to correct section on the page.
                eval($message);
                Lfl.Ajax.ResponseParser.moveJavascript($message);
            };

            /**
             * @memberOf Lfl.FlashMessages.Displayer
             */
            Displayer.displayAll = function(messagesHtmlArray) {

                _.each(messagesHtmlArray, function(messageHtml, key) {
                    Displayer.display(messageHtml);
                });
            };
            /*
            |-----------------------------------------------------------------------------------------------------------
            | Private methods
            |-----------------------------------------------------------------------------------------------------------
            */
        }(FlashMessages.Displayer = FlashMessages.Displayer || {}, jQuery));
    }(Lfl.FlashMessages = Lfl.FlashMessages || {}, jQuery));
}(window.Lfl = window.Lfl || {}, jQuery));